import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {Collapse} from '@mui/material';
import {AccessTime, AccountBalance, AccountTree, Assignment, AttachMoney, Ballot, CalendarMonth, DirectionsCar, ExpandLess, ExpandMore, Factory, Group, History, Inventory, List, LocalPolice, LocalShipping, MoveDown, Newspaper, PrecisionManufacturing, Receipt, School, Settings, ShoppingCart, SpeakerNotes, Storage, Warehouse} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import authService from "../../services/AuthService";


export function MainListItems(permissions) {

    const navigate = useNavigate();
    const [openTasks, setOpenTasks] = React.useState(false);
    const [openStorage, setOpenStorage] = React.useState(false);
    const [openSettings, setOpenSettings] = React.useState(false);
    const [openProjects, setOpenProjects] = React.useState(false);
    const role = authService.getCurrentUser().role;
    const url = window.location.pathname
    const selectedMenuItem = {backgroundColor: "gray", color: "white"}
    const menuItems = [
        {path: "/dashboard/task-logs", label: "Munkaidő", icon: <AccessTime/>, permission: 'TASK_LOG_READER'},
        {path: "/dashboard/tasks", label: "Feladatok", icon: <Assignment/>, permission: 'TASK_READER'},

        {
            label: "Projektek",
            icon: <Newspaper/>,
            collapsible: true,
            open: openProjects,
            toggleOpen: () => setOpenProjects(!openProjects),
            subItems: [
                {path: "/dashboard/projects/overview", label: "Áttekintés", icon: <AccountTree/>, permission: 'PROJECT_EDITOR'},
                {path: "/dashboard/product-projects", label: "Termék Projektek", icon: <PrecisionManufacturing/>, permission: 'PRODUCT_PROJECT_READER'},
                {path: "/dashboard/project-tasks/calendar", label: "Naptár", icon: <CalendarMonth/>, permission: 'PROJECT_TASK_READER', prohibitedForGuest: true},
                {path: "/dashboard/project-tasks/projects", label: "Projekt Feladatok", icon: <List/>, permission: 'PROJECT_TASK_READER'},
            ]
        },
        {path: "/dashboard/manufacturing-process", label: "Gyártási Folyamatok", icon: <Factory/>, permission: 'PRODUCT_READER'},
        {
            label: "Raktár",
            icon: <Warehouse/>,
            collapsible: true,
            open: openStorage,
            toggleOpen: () => setOpenStorage(!openStorage),
            subItems: [
                {path: "/dashboard/storage/products", label: "Termékek", icon: <Inventory/>, permission: 'PRODUCT_READER'},
                {path: "/dashboard/storage/to-order", label: "Rendelendő", icon: <ShoppingCart/>, permission: 'PRODUCT_READER'},
                {path: "/dashboard/storage/move", label: "Mozgatás", icon: <MoveDown/>, permission: 'PRODUCT_EDITOR'},
                {path: "/dashboard/storage/logs", label: "Történet", icon: <History/>, permission: 'STORAGE_LOG_READER'},
                {path: "/dashboard/storage/substorages", label: "Alraktárak", icon: <Storage/>, permission: 'SUB_STORAGE_READER'}
            ]
        },
        {
            label: "Beállítások",
            icon: <Settings/>,
            collapsible: true,
            open: openSettings,
            toggleOpen: () => setOpenSettings(!openSettings),
            subItems: [
                {path: "/dashboard/projects", label: "Projektek", icon: <Assignment/>, permission: 'PROJECT_READER'},
                {path: "/dashboard/partners", label: "Partnerek", icon: <LocalShipping/>, permission: 'PARTNER_READER'},
                {path: "/dashboard/task-types", label: "Feladatkörök", icon: <Ballot/>, permission: 'TASK_TYPE_READER'},
                {path: "/dashboard/users", label: "Felhasználók", icon: <Group/>, permission: 'USER_READER'},
                {path: "/dashboard/vehicles", label: "Járművek", icon: <DirectionsCar/>, permission: 'VEHICLE_READER'},
                {path: "/dashboard/global-payment-modifiers", label: "Globális Értékek", icon: <AccountBalance/>, permission: 'GLOBAL_PAYMENT_MODIFIER_READER'},
                {path: "/dashboard/permissions", label: "Jogosultságok", icon: <LocalPolice/>, permission: 'ROLE_MATRIX_READER'}
            ]
        },
        {path: "/dashboard/payrolls", label: "Fizetések", icon: <AttachMoney/>, permission: 'PAYROLL_READER'},
        {path: "/dashboard/simple-invoices", label: "Számlák", icon: <Receipt/>, permission: 'INVOICE_READER'},
        {path: "/dashboard/notes", label: "Jegyzetek", icon: <SpeakerNotes/>, permission: 'NOTE_READER'},
        {path: "/dashboard/tools", label: "Tudásbázis", icon: <School/>, permission: 'TOOL_READER'},
    ];

    return (
        <React.Fragment>
            {menuItems.map((item, index) => (
                <React.Fragment key={index}>
                    <ListItemButton
                        onClick={item.collapsible ? item.toggleOpen : () => navigate(item.path)}
                        sx={url.startsWith(item.path) ? selectedMenuItem : {}}
                        disabled={(item.prohibitedForGuest && role === 'ROLE_GUEST')
                            || (item.collapsible && !item.subItems.map(s => s.permission).some(item => permissions.includes(item)))
                            || (item.permission != null && !item.collapsible && !permissions.includes(item.permission))}
                    >
                        <ListItemIcon>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.label}/>
                        {item.collapsible && (item.open ? <ExpandLess/> : <ExpandMore/>)}
                    </ListItemButton>

                    {item.collapsible && (
                        <Collapse in={item.open} timeout="auto" unmountOnExit>
                            {item.subItems.map((subItem) => (
                                <ListItemButton
                                    key={subItem.path}
                                    onClick={() => navigate(subItem.path)}
                                    sx={url.startsWith(subItem.path) ? selectedMenuItem : {}}
                                    disabled={!permissions.includes(subItem.permission) || (subItem.prohibitedForGuest && role === 'ROLE_GUEST')}
                                >
                                    <ListItemIcon style={{marginLeft: "20px"}}>
                                        {subItem.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={subItem.label}/>
                                </ListItemButton>
                            ))}
                        </Collapse>
                    )}
                </React.Fragment>
            ))}
        </React.Fragment>
    );
}